<template>
    <div @mouseenter="showLikes" @mouseleave="hideLikes" @click="showCommentLikeListModal" class="comment-like-counter">
        <span v-if="commentLikes.length" class="small" style="color: #022A8A;"><i class="fa fa-thumbs-up small mr-1"></i>{{ commentLikes.length }}</span>
        <transition name="fade">
            <div v-if="likesToolTipOpen && commentLikes.length" class="post-tooltip">
                <div class="tooltiptext">
                    <ul class="list-unstyled mb-0">
                        <li class="small text-truncate" v-for="like in trimmedLikeList">{{ like.employee.first_name }} {{ like.employee.last_name }}</li>
                        <li v-if="likesNotShownCount > 0" class="small">and {{ likesNotShownCount }} more...</li>
                    </ul>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import eventBus from '@/event-bus';

const MOBILE_WIDTH = 768;

export default {
    props: {
        commentLikes: {
            type: Array,
            default() {
                return [];
            }
        },
        user: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            likesToolTipOpen: false,
            isMobile: false
        }
    },
    mounted() {
        if (window.innerWidth < MOBILE_WIDTH) {
            this.isMobile = true;
        }

        eventBus.$on('windowResized', (width) => {
            this.isMobile = width <= MOBILE_WIDTH;
        })
    },
    methods: {
        showLikes() {
            if (!this.isMobile) {
                this.likesToolTipOpen = true;
            }
        },
        hideLikes() {
            this.likesToolTipOpen = false;
        },
        showCommentLikeListModal() {
            this.$emit('likeListModalOpened', this.commentLikes);
        }
    },
    computed: {
        liked() {
            return this.commentLikes.filter(like => like.employee_id === this.user.employee_id).length > 0;
        },
        trimmedLikeList() {
            return this.commentLikes.filter((like, index) => (index + 1) <= 10);
        },
        likesNotShownCount() {
            return this.commentLikes.length - this.trimmedLikeList.length;
        }
    }
}
</script>

<style lang="scss" scoped>
.comment-like-button {
    line-height: 0;

    a {
        line-height: 1;

        &.active {
            color: #022A8A;
        }
    }
}

</style>
